import { cdnDomain } from "@/constants/cdnUrls";

/**
 * Converts a local bus image path to CDN path
 * @param {string} imagePath - Local image path (e.g., "/images/bus/desktop-background.png")
 * @returns {string} CDN path (e.g., "https://cdn.turna.com/saka/bus/desktop-background.png")
 */
export const getCdnImagePath = (imagePath) => {
  if (!imagePath) {
    return "";
  }

  // If already a full URL, return as is
  if (imagePath.startsWith("http://") || imagePath.startsWith("https://")) {
    return imagePath;
  }

  // Remove leading slash if present
  const cleanPath = imagePath.startsWith("/") ? imagePath.slice(1) : imagePath;

  return `${cdnDomain}${cleanPath}`;
};
